import {
  Box,
  Button,
  Grid,
  InputLabel,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC } from "react";
import useResponsive from "../../hooks/useResponsive";
import { labelSty } from "../UIElements/styles-input";

import {
  InputCustomIcon,
  InputCustomSize,
  TextArea,
} from "../UIElements/input-ui";
import SelectInput from "../UIElements/select";
import { PostJobProps } from "../../interface/job_board";
import { CalenderIcon, LocationIcon } from "../UIElements/svg-icons";
import CustomDatePicker from "../UIElements/date-picker";
import { Dayjs } from "dayjs";
import { CustomRange } from "../UIElements/range";
import SelectInputMultiple from "../UIElements/select-multiple";

const AddHospitalForm: FC<{
  jobDetails: PostJobProps;
  handleDocumentChange: (event: any) => void;
  document: string[];
  salary: { min: string; max: string };
  handleSalary: React.Dispatch<
    React.SetStateAction<{ min: string; max: string }>
  >;
  changeJobDetails: React.Dispatch<React.SetStateAction<PostJobProps>>;
  selectDate: Dayjs | null;
  changeSelectDate: (e: any) => void;
}> = ({
  jobDetails,
  changeJobDetails,
  selectDate,
  changeSelectDate,
  document,
  salary,
  handleSalary,
  handleDocumentChange,
}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  const headerSty = {
    fontFamily: "Lexend",
    fontWeight: 500,
    my: isMedium ? 2 : 3,
    color: theme.palette.neutral.light,
  };
  const btnSty = {
    width: 120,
    borderRadius: "12px",
    padding: "6px 14px",
    background: "#284CB133",
    color: "#1E1E1E",
    fontSize: "12px",
    fontWeight: 700,
  };

  return (
    <Box sx={{}}>
      <Box>
        <Typography sx={{ ...headerSty, my: 2 }} variant="subtitle2">
          Hospital Details
        </Typography>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 2, gap: 2 }}
        >
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <InputLabel sx={{ ...labelSty, mb: 0 }}>Name</InputLabel>
            <InputCustomSize
              placeholder={"Enter text here"}
              value={jobDetails?.job_title}
              onchange={(e: any) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  job_title: e.target.value,
                }))
              }
              type={""}
              size={"medium"}
              styles={undefined}
            />
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <SelectInput
              label={"Speciality"}
              value={jobDetails?.department ?? ""}
              onChange={(e) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  department: e.target.value,
                }))
              }
              options={[
                { value: "", label: "" },
               
              ]}
            />
          </Stack>
        </Stack>
        <Stack sx={{ width: "100%", my: 2 }}>
          <InputLabel sx={{ ...labelSty, mb: 0 }}>Hospital Description</InputLabel>
          <TextArea
            placeholder={
              "Provide a detailed description of the responsibilities, duties, and expectations."
            }
            value={jobDetails?.job_description}
            onchange={(e: any) =>
              changeJobDetails((prev) => ({
                ...prev,
                job_description: e.target.value,
              }))
            }
          />
        </Stack>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 2, gap: 2 }}
        >
         
         <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <SelectInput
              label={"Staff Range"}
              value={jobDetails?.experience_level}
              onChange={(e) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  experience_level: e.target.value,
                }))
              }
              options={[
                { value: "1 - 20", label: "1 - 20" },
                { value: "21 - 49", label: "21 - 49" },
                { value: "50 - 90", label: "50 - 90" },
                { value: "91 - 150", label: "91 - 150" },
              ]}
            />
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <SelectInput
              label={"Bed Range"}
              value={jobDetails?.experience_level}
              onChange={(e) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  experience_level: e.target.value,
                }))
              }
              options={[
                { value: "1 - 10", label: "1 - 10" },
                { value: "11 - 40", label: "11 - 40" },
                { value: "41 - 90", label: "41 - 90" },
                { value: "91 - 140", label: "91 - 140" },
              ]}
            />
          </Stack>
        </Stack>
      </Box>

      {/*  */}
      <Box>
        <Typography sx={{ ...headerSty, my: 0, mb: 2 }} variant="subtitle2">
        Work Schedule
        </Typography>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 2, gap: 2 }}
        >
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <InputLabel sx={{ ...labelSty, mb: 0 }}>Work Schedule</InputLabel>
            <InputCustomSize
              placeholder={"e.g., 9 AM - 5 PM, Night Shift, On-Call"}
              value={jobDetails?.work_schedule}
              onchange={(e: any) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  work_schedule: e.target.value,
                }))
              }
              type={""}
              size={"medium"}
              styles={undefined}
            />
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <SelectInput
              label={"Shifting"}
              value={jobDetails?.employment_type}
              onChange={(e) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  employment_type: e.target.value,
                }))
              }
              options={[
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ]}
            />
          </Stack>
        </Stack>
      
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 2, gap: 2 }}
        >
            
        
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <SelectInput
              label={"Shift Amount"}
              value={jobDetails?.work_type}
              onChange={(e) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  work_type: e.target.value,
                }))
              }
              options={[
                { value: "on-site", label: "On site" },
                { value: "remote", label: "Remote" },
                { value: "hybrid", label: "Hybrid" },
              ]}
            />
          </Stack>
          
        </Stack>
      </Box>
      
      <Box>
        <Typography sx={{ ...headerSty, mt: 3, my: 2 }} variant="subtitle2">
          Location
        </Typography>
       
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ mb: 2, gap: 2 }}
        >
      <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <InputLabel sx={{ ...labelSty, mb: 0 }}>Work Location</InputLabel>
            <InputCustomIcon
              icon={<LocationIcon />}
              placeholder={"Enter location here"}
              value={jobDetails?.work_location}
              onchange={(e: any) =>
                changeJobDetails((prev) => ({
                  ...prev,
                  work_location: e.target.value,
                }))
              }
              type={"text"}
              size={"medium"}
              styles={undefined}
            />
          </Stack>
          
        </Stack>
       
       
      </Box>
    </Box>
  );
};

export default AddHospitalForm;
